<template>
  <div class="body">
    <!--   上传中 progress  -->
    <div
      v-if="uploadState === 'progress'"
      class="upload-demo"
    >
      <div class="file-name">
        <img class="file-icon" :src="`https://images.hipccdn.com/images/file_icon/new/${fileData.type}.svg`">
        <span>{{ fileData.name }}</span>
      </div>
      <div class="upload-box">
        <el-progress width="220" stroke-width="10" type="circle" :percentage="progressNum" :show-text="false" format="上传中"></el-progress>
        <span class="text" @click="cancelHandle">取消</span>
      </div>
    </div>
    <!--   上传失败 error  -->
    <div
      v-else-if="uploadState === 'error'"
      class="upload-demo"
    >
      <div class="file-name">
        <img class="file-icon" :src="`https://images.hipccdn.com/images/file_icon/new/${fileData.type}.svg`">
        <span>{{ fileData.name }}</span>
      </div>
      <div class="upload-box">
        <img class="fileTransfer-icon" src="@/assets/image/error.png">
        <span>上传失败</span>
        <section class="gary-text">
          <p>{{ message }}</p>
        </section>
        <el-button style="margin-top: 20px" size="small" type="primary" round @click="uploadState = 'not'">重新上传</el-button>
      </div>
    </div>
    <!--   上传成功 sucess  -->
    <div
      v-else-if="uploadState === 'success'"
      class="upload-demo"
    >
      <div class="file-name">
        <img class="file-icon" :src="`https://images.hipccdn.com/images/file_icon/new/${fileData.type}.svg`">
        <span>{{ fileData.name }}</span>
      </div>
      <div class="upload-box">
        <img class="fileTransfer-icon" src="@/assets/image/share.png">
        <span clas="text-xs text-neutral-N700 dark:text-neutral-DN700 font-normal">上传成功</span>
        <section class="gary-text">
          <p>分享链接给好友即可查看</p>
          <p>链接7天有效</p>
        </section>
        <el-button size="small" type="primary" round  @click="copyHandle">复制链接</el-button>
        <el-button size="small" type="primary" plain round  @click="uploadState = 'not'">继续上传</el-button>
      </div>
    </div>
    <!--   选取文件 not  -->
    <section v-else>
      <input type="file" ref="fileRef" @input="changeFile">
      <div
        @click.stop="uploadHandle()"
        class="upload-demo"
      >
        <div class="upload-box">
          <img class="fileTransfer-icon" src="@/assets/image/upload.png">
          <span>点击添加文件</span>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {copyText, fileType, fs} from "@/utils/util";
import useCosUpload from "@/api/cos/index";
const {cancelUpload, uploadFiles} = useCosUpload('hipc-cloud-1251304130')

import { postShaerFile } from "@/api/sharefiles";

export default {
  name: "FileTransfer",
  data() {
    return {
      data_opt: null, // 请求必带参数
      fileData: {}, // 当前上传的文件信息
      uploadState: 'not', // 上传状态 not-没有文件 progress-上传中进度条 error-上传失败 success-上传成功
      progressNum: 0, // 上传进度
      successLink: '', // 上传成功后的可复制的链接
      message: '', // 提示
    };
  },
  created() {
    localStorage.setItem('data_opt', this.$route.query.query)
    this.data_opt = JSON.parse(this.$route.query.query)
  },
  computed: {},
  mounted() {

  },
  methods: {

    /**
     * 复制链接
     */
    copyHandle() {
      copyText(this.successLink)
    },

    /**
     * 取消上传
     */
    cancelHandle() {
      cancelUpload()
      this.uploadState = 'not'
    },

    /**
     * 触发上传
     */
    uploadHandle() {
      this.$refs.fileRef.click()
    },

    /**
     * 上传文件
     * @param e
     */
    changeFile(e) {
      const file = e.target.files[0]
      const num = file.size / 1024;
      const fileSize = parseInt(num.toFixed(0));
      // 用户可上传文件大小是否大于当前选择文件的大小
      let isLt2M = fileSize < this.data_opt.maxFilesize;

      if (isLt2M) { // 判断大小
        // 上传文件数据(回显使用)
        this.fileData.name = file.name;
        this.fileData.type = fileType(file.name);

        this.uploadState = 'progress'// 切换上传状态

        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        const path = `/share/haipc/${year}${month}${day}/`; //存储目录

        const lastIndex = file.name.lastIndexOf(".");
        const suffix = file.name.slice(lastIndex);
        const name = file.name.slice(0, lastIndex);
        const storaFileName = `${name}_${Date.now()}${suffix}`; //存储文件名

        uploadFiles(path, storaFileName, file, (err, data) => { // 上传储存桶
            if (!err) {
              postShaerFile({
                file_key: `${path}${storaFileName}`,
                file_name: file.name,
                filesize: file.size,
                context: JSON.stringify(data),
              }).then(res => {
                this.uploadState = 'success' // 切换成功状态
                this.successLink = `${this.data_opt.platform.includes('_') ? 'http://pc-beta.hipc.cn/s/' : 'https://pc.hipc.cn/s/'}${res.data.encryption_key}`; // 保存链接
              })
            } else {
              this.uploadState = 'error' // 切换失败状态
            }
          },(progress) => { // 保存上传进度
            this.progressNum = progress.percent * 100
          }
        )
      } else { // 用户文件不符合上传要求
        this.uploadState = 'error' // 切换失败状态
        this.message = `文件大于${fs(this.data_opt.maxFilesize * 1024)}`
      }
    },
  },
  beforeDestroy() {}
};
</script>
<style scoped>
.body {
  width: 100%;
  height: 100vh;
}
@media (min-width: 768px) {

}

input {
  display: none;
}

.upload-demo {
  margin: 10vh auto;
  width: 80vw;
  height: 80vh;
  border-radius: 16px;
  border: 2px dashed rgba(9, 30, 66, 0.16);
  color: #172B4D;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  padding: 8px;
  box-sizing: border-box;
}

.upload-box {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.fileTransfer-icon {
  width: 56px;
  height: 56px;
  margin-bottom: 12px;
}

.text {
  color: #626F86;
  margin-top: 50px;
}

.file-name {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 4px;
  padding: 8px;
  box-sizing: border-box;
}

.file-name span {
  white-space: nowrap;         /* 防止文本换行 */
  overflow: hidden;            /* 隐藏超出的文本 */
  text-overflow: ellipsis;     /* 使用省略号表示超出部分 */
  color:  #172B4D;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  max-width: 250px;
}


.file-icon {
  width: 16px;
  height: 16px;
  border-radius: 4px;
}

.gary-text {
  color: #626F86;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin-top: 16px;
}

.el-button {
  margin: 20px 0 0 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/hipc/FileTransfer.vue